// components/PoolTable.js
import React from "react";
import PoolTableRow from "./PoolTableRow";
import PoolPagination from "./PoolPagination";
import { tableHeaders } from "../../../utils/constant";

const PoolTable = ({ rootPoolData, loading, onShare, childPools }) => {
   
    // console.log(childPools, "Child pool")

    if (loading) {
        return <div className="table_main">Loading rootPoolData...</div>;
    } 

    return (
        <div className="table_main">
            <div className="table_innner">
                {tableHeaders?.map((header, index) => (
                    <p key={index} className={index === 0 ? "one_sidee" : ""}>
                        {header}
                    </p>
                ))}
            </div>

            {childPools?.length > 0 ? (
                childPools?.map((pool, index) => (
                    <PoolTableRow
                        key={pool._id || index}
                        pool={pool}
                        index={index}
                        onShare={onShare}
                        rootPoolData={rootPoolData}
                    />
                ))
            ) : (
                null
            )}
        </div>
    );
};

export default PoolTable;